type RandomSource = { getRandomValues: <T extends Uint8Array>(array: T) => T };

/**
 * Web Crypto rather than `node:crypto`, because this package is bundled into
 * the portal as well as run in the API and a Node import would break that
 * build.
 */
export function randomBytes(length: number): Uint8Array {
  const source = (globalThis as { crypto?: RandomSource }).crypto;
  if (!source?.getRandomValues) throw new Error('No cryptographic random source is available');
  return source.getRandomValues(new Uint8Array(length));
}
